// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"94c98ee1","79":"3480076d","134":"60b6cd6d","296":"f74ab4c2","512":"3bbae809","685":"b9cc8ae1","756":"e60d9d7e","841":"59f0b21b","971":"38709377"}[chunkId] + ".chunk.js";
};